import { ChevronDown, ChevronUp } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from '../../../../components/ui/RadioGroup';
import React, { useState, useEffect } from 'react';
import { usePermission } from '../../../../hooks/usePermission';

const styles: Record<string, React.CSSProperties> = {
  tree: {
    position: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    verticalAlign: 'middle',
  },
  toggle: {
    width: '1em',
    height: '1em',
    cursor: 'pointer',
    verticalAlign: 'middle',
  },
  contents: {
    willChange: 'transform, opacity, height',
    padding: '2.5px 0px 0px 28px',
  },
};

function Contents({ children, ...style }: any, open: boolean) {
  const newStyle = open
    ? { opacity: 1, height: 'auto', ...style }
    : { opacity: 0, height: 0, ...style };

  return <div style={{ ...newStyle, ...styles.contents }}>{children}</div>;
}

interface TreeProps {
  open?: boolean;
  visible?: boolean;
  children?: React.ReactNode;
  content?: React.ReactNode;
  style?: React.CSSProperties;
  status?: number;
  changeRules?: (value: string) => void;
  canHide?: boolean;
}

function Tree(props: TreeProps) {
  const { isEditable } = usePermission();
  const [state, setState] = useState<{ open: boolean; visible: boolean }>({
    open: props.open || true,
    visible: props.visible || true,
  });

  const toggle = () => {
    if (props.children) {
      setState({ ...state, open: !state.open, visible: false });
    }
  };

  useEffect(() => {
    const newState = { open: props.open ?? state.open, visible: props.visible ?? state.visible };
    setState(newState);
  }, [props]);

  const { children, content, style, status } = props;

  const radioValues = [1, 2, 0]; // cteni, editace, odeprit

  return (
    <div className="text-(--ink-600) text-sm" style={{ ...styles.tree, ...style }}>
      <div className="h-7.5 items-center flex justify-between border-b border-dotted border-color3 pl-2.5">
        <div className="flex items-center">
          <span className="`mr-1.25">
            {children ? (
              state.open ? (
                <ChevronUp
                  className="h-4 w-4"
                  data-testid="rights-tree-collapse-btn"
                  onClick={toggle}
                />
              ) : (
                <ChevronDown
                  className="h-4 w-4"
                  data-testid="rights-tree-expand-btn"
                  onClick={toggle}
                />
              )
            ) : (
              ''
            )}
          </span>
          <span className="pl-1.25">{content}</span>
        </div>
        <RadioGroup
          className="flex items-center gap-0"
          onValueChange={(value) => props.changeRules?.(value)}
          value={String(status)}
          disabled={!isEditable}
        >
          {radioValues.map((ele) => (
            <div key={ele} className="flex justify-center w-17.5">
              <RadioGroupItem
                value={String(ele)}
                id={`tree-radio-${ele}`}
                data-testid={`rights-tree-radio-${ele}`}
              />
            </div>
          ))}
        </RadioGroup>
      </div>
      {Contents(props, state.open)}
    </div>
  );
}

export default Tree;
